const PatientCardStyle = () => {
  return {
    card: {
      background: 'white',
      color: '#1a1a1a',
      marginBottom: '16px',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        borderColor: '#0ea5e9',
        transform: 'translateY(-2px)',
      },
    },
    cardContent: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '20px',
    },
    avatar: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '18px',
      fontWeight: '600',
      flexShrink: 0,
      transition: 'transform 0.2s ease',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    infoSection: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    patientName: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '4px',
    },
    infoRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: '24px',
      flexWrap: 'wrap',
    },
    infoItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      alignItems: 'center'
    },
    label: {
      fontSize: '11px',
      fontWeight: '500',
      color: '#666',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    value: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#1a1a1a',
    },
    insuranceBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      marginTop: '2px',
    },
    insured: {
      backgroundColor: '#dcfce7',
      color: '#16a34a',
    },
    uninsured: {
      backgroundColor: '#fee2e2',
      color: '#dc2626',
    },
  };
};

export default PatientCardStyle;
